import React from 'react'
import ClassmatesSearch from '../PhotosSearchForm/ClassmatesSearch'
import CompaniesSearch from '../PhotosSearchForm/CompaniesSearch'
import CategoriesSearch from '../PhotosSearchForm/CategoriesSearch'
import TimeframesSearch from '../PhotosSearchForm/TimeframesSearch'
import ServiceSearch from '../PhotosSearchForm/ServiceSearch'
import BranchSearch from '../PhotosSearchForm/BranchSearch'

const {
  classmateOptions
} = /** @type {PhotoSearchDataSet} */ window.PhotoSearchData

function SearchForm ({ state, setState, varNames }) {
  return (
    <div className='photos-search-form'>
      <ClassmatesSearch
        classmateOptions={classmateOptions}
        setState={setState}
        state={state}
        varNames={varNames}
      />
      <CompaniesSearch
        setState={setState}
        state={state}
        varNames={varNames}
      />
      <CategoriesSearch
        setState={setState}
        state={state}
        varNames={varNames}
      />
      <TimeframesSearch
        setState={setState}
        state={state}
        varNames={varNames}
      />
      <ServiceSearch
        setState={setState}
        state={state}
        varNames={varNames}
      />
      <BranchSearch
        setState={setState}
        state={state}
        varNames={varNames}
      />
    </div>
  )
}

export default SearchForm
